<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Accessories</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (communicatingServiceToolSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(communicatingServiceToolSelection.Name)"
              for="communicatingServiceToolInput" class="halfWidthInputLabel">Communicating Service Tool:</label>
              <input type="checkbox" class="checkboxInput" id="communicatingServiceToolInput"
                #antiScaldValveInput [checked]="'true' === communicatingServiceToolSelection.Value"
                (change)="selectionChanged(communicatingServiceToolSelection, antiScaldValveInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (smartTankSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">iGate 2 Smart Tank:</label>
              <select class="halfWidthInputField" #smartTankInput
                [class.invalidConfigurationSelection]="isInvalidSelection(smartTankSelection.Name)"
                (change)="selectionChanged(smartTankSelection, smartTankInput.value)"
                [value]="smartTankSelection.Value.toString()">
                @for (allowable of smartTankSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="smartTankSelection.Value && smartTankSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (outdoorTempSensorSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(outdoorTempSensorSelection.Name)"
              for="outdoorTempSensorInput" class="halfWidthInputLabel">Outdoor Temperature Sensor:</label>
              <input type="checkbox" class="checkboxInput" id="outdoorTempSensorInput"
                #antiScaldValveInput [checked]="'true' === outdoorTempSensorSelection.Value"
                (change)="selectionChanged(outdoorTempSensorSelection, antiScaldValveInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (antiScaldValveSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(antiScaldValveSelection.Name)"
              for="antiScaldValveInput" class="halfWidthInputLabel">Anti-Scald Valve:</label>
              <input type="checkbox" class="checkboxInput" id="antiScaldValveInput"
                #antiScaldValveInput [checked]="'true' === antiScaldValveSelection.Value"
                (change)="selectionChanged(antiScaldValveSelection, antiScaldValveInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (compressorSoftStartKitSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(compressorSoftStartKitSelection.Name)"
              for="compressorSoftStartKitInput" class="halfWidthInputLabel">Compressor Soft Start Kit:</label>
              <input type="checkbox" class="checkboxInput" id="compressorSoftStartKitInput"
                #compressorSoftStartKitInput [checked]="'true' === compressorSoftStartKitSelection.Value"
                (change)="selectionChanged(compressorSoftStartKitSelection, compressorSoftStartKitInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (unitPadSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(unitPadSelection.Name)"
              for="unitPadInput" class="halfWidthInputLabel">Unit Pad:</label>
              <input type="checkbox" class="checkboxInput" id="unitPadInput"
                #accessoryPumpControlModuleInput [checked]="'true' === unitPadSelection.Value"
                (change)="selectionChanged(unitPadSelection, accessoryPumpControlModuleInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (packagedUnitStandSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(packagedUnitStandSelection.Name)"
              for="packagedUnitStandInput" class="halfWidthInputLabel">Packaged Unit Stand:</label>
              <input type="checkbox" class="checkboxInput" id="packagedUnitStandInput"
                #accessoryPumpControlModuleInput [checked]="'true' === packagedUnitStandSelection.Value"
                (change)="selectionChanged(packagedUnitStandSelection, accessoryPumpControlModuleInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (extendedWarrantySelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(extendedWarrantySelection.Name)"
              for="extendedWarrantyInput" class="halfWidthInputLabel">Extended Warranty:</label>
              <input type="checkbox" class="checkboxInput" id="extendedWarrantyInput"
                #extendedWarrantyInput [checked]="'true' === extendedWarrantySelection.Value"
                (change)="selectionChanged(extendedWarrantySelection, extendedWarrantyInput.checked.toString())">
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
